import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-hexagon-arrow-svg',
  standalone: true,
  template: `
    <svg width="10" height="87" viewBox="0 0 10 87" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g style="mix-blend-mode:lighten">
        <path d="M7.2973 0H3.24324L0 87H10L7.2973 0Z" fill="url(#paint0_linear_hex_arrow)" fill-opacity="0.75"/>
      </g>
      <defs>
        <linearGradient id="paint0_linear_hex_arrow" x1="5" y1="0" x2="5" y2="87" gradientUnits="userSpaceOnUse">
          <stop stop-color="#FB5858"/>
          <stop offset="0.4" stop-color="#A23D3D" stop-opacity="0.7"/>
          <stop offset="1" stop-color="#1B1A1A"/>
        </linearGradient>
      </defs>
    </svg>
  `,
  styles: [`
    :host {
      display: block;
    }
    svg {
      display: block;
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HexagonArrowSvgComponent {}
